/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpArrowDownH: {
  name: 'arrow-up-arrow-down-h';
  data: string;
} = {
  name: 'arrow-up-arrow-down-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.354 1.646a.5.5 0 0 0-.708.708L13.793 3.5H1a.5.5 0 0 0 0 1h12.793l-1.147 1.146a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2Zm-10 8.708a.5.5 0 0 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L2.207 12.5H15a.5.5 0 0 0 0-1H2.207l1.147-1.146Z" fill="currentColor"/></svg>`,
};
